export default "__VITE_ASSET__b223a309__"